export function dateKeyFromString(dateStr) {
  if (!dateStr) return '';
  const s = String(dateStr).trim();
  const part = s.split(' ')[0].split('T')[0];
  return part.length >= 10 ? part.slice(0, 10) : part;
}

export function getLocalDateKey(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function toDateOrNull(dateKey) {
  if (!dateKey) return null;
  const d = new Date(`${dateKey}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

export function addDays(dateKey, deltaDays) {
  const base = toDateOrNull(dateKey);
  if (!base) return '';
  base.setDate(base.getDate() + deltaDays);
  return getLocalDateKey(base);
}

export function monthKeyFromDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

export function startOfWeekKey(dateKey) {
  const d = toDateOrNull(dateKey);
  if (!d) return '';
  const day = d.getDay();
  const mondayOffset = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + mondayOffset);
  return getLocalDateKey(d);
}

export function endOfWeekKey(dateKey) {
  const start = startOfWeekKey(dateKey);
  return start ? addDays(start, 6) : '';
}

export function isDateInRange(dateKey, fromDate, toDate) {
  if (!dateKey) return false;
  if (fromDate && dateKey < fromDate) return false;
  if (toDate && dateKey > toDate) return false;
  return true;
}

/** ISO week number (same rules as the browser week picker). */
export function getIsoWeekInfo(dateObj) {
  const date = new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()));
  const dayNum = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
  return { year: date.getUTCFullYear(), week: weekNo };
}

export function weekInputFromDateKey(dateKey) {
  const d = new Date(`${dateKey}T00:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  const { year, week } = getIsoWeekInfo(d);
  return `${year}-W${String(week).padStart(2, '0')}`;
}

export function weekRangeFromInput(weekInput) {
  const m = /^(\d{4})-W(\d{2})$/.exec(String(weekInput || ''));
  if (!m) return { fromDate: '', toDate: '' };
  const year = Number(m[1]);
  const week = Number(m[2]);
  const jan4 = new Date(Date.UTC(year, 0, 4));
  const jan4Day = jan4.getUTCDay() || 7;
  const week1Monday = new Date(jan4);
  week1Monday.setUTCDate(jan4.getUTCDate() - (jan4Day - 1));
  const weekMonday = new Date(week1Monday);
  weekMonday.setUTCDate(week1Monday.getUTCDate() + (week - 1) * 7);
  const weekSunday = new Date(weekMonday);
  weekSunday.setUTCDate(weekMonday.getUTCDate() + 6);
  return {
    fromDate: weekMonday.toISOString().slice(0, 10),
    toDate: weekSunday.toISOString().slice(0, 10),
  };
}

/** ISO week range containing the given local calendar day. */
export function isoWeekRangeForDateKey(dateKey) {
  const weekKey = weekInputFromDateKey(dateKey);
  return { weekKey, ...weekRangeFromInput(weekKey) };
}
